module.exports = __webpack_public_path__ + "static/img/like.b8f4c2ad.gif";